export const YEAR_OPTIONS = Array.from({ length: 7 }, (_, index) => {
  const currentYear = new Date().getFullYear();
  const year = currentYear - 3 + index;
  return { label: String(year), value: String(year) };
});

export const QUARTER_OPTIONS = [
  { label: "Q1", value: "Q1" },
  { label: "Q2", value: "Q2" },
  { label: "Q3", value: "Q3" },
  { label: "Q4", value: "Q4" },
];

export const MONITORING_SECTIONS = [
  {
    code: "1.0",
    title: "Coordination, Plan Implementation, and M&E",
    marksLabel: "Planning and related issues - 34 marks",
    icon: "Network",
    indicators: [
      {
        code: "1.1",
        title: "Functionality of District Planning Coordinating Unit based on the Guidelines for the Operationalization of DPCUs",
        context: "District = 23, Municipal = 25, Metros = 26",
        maxScore: 5,
        meansOfVerification: [
          "Minutes of DPCU Meeting",
          "Dispatch books",
          "WhatsApp messages on the DPCU",
        ],
      },
      {
        code: "1.2",
        title: "Submission of the 2nd Quarter, 2025 Progress Report to the Regional Coordinating Council (RCC) and the NDPC",
        maxScore: 2,
        meansOfVerification: [
          "2nd Quarter Progress Report",
          "RCC Receipt Book",
          "Dispatch Book",
        ],
      },
      {
        code: "1.3",
        title: "Updates of District Development Data Platform (DDDP)",
        maxScore: 10,
        meansOfVerification: [
          "Practical demonstration of usage",
          "DDDP Platform",
          "Trackers",
        ],
      },
      {
        code: "1.4",
        title: "District LED activities in the 2025 AAP",
        maxScore: 4,
        meansOfVerification: [
          "2024 Annual Action Plan",
          "LED Platforms or Committees Minutes",
          "Quarterly Progress Reports",
          "Departmental Implementation Reports",
        ],
      },
    ],
  },
  {
    code: "2.0",
    title: "Physical Planning",
    marksLabel: "5 marks",
    icon: "Map",
    indicators: [
      {
        code: "2.1",
        title: "Meetings of the Technical Sub-Committee and Spatial Planning Committee (SPC)",
        maxScore: 3,
        meansOfVerification: [
          "Technical Sub-Committee and Spatial Planning Committee files",
          "Signed Minutes of Meetings (TSC and SPC)",
          "Technical Sub-Committee reports",
          "Development permit records",
        ],
      },
      {
        code: "2.2",
        title: "Planning and Development Permit Processing and Issuance",
        maxScore: 1,
        meansOfVerification: [
          "Notice Boards",
          "TSC Reports or Minutes",
          "Invitation Letters to SPC Meetings",
          "Signed Minutes of SPC Meetings",
          "Permits Record",
        ],
      },
    ],
  },
  {
    code: "3.0",
    title: "Procurement",
    marksLabel: "4 marks",
    icon: "ClipboardList",
    indicators: [
      {
        code: "3.1",
        title: "District Procurement Plan available and prepared based on Public Procurement Act, 2003 (Act 663), as amended",
        maxScore: 4,
        meansOfVerification: [
          "Procurement Plan",
          "Updated Procurement Plan",
          "Annual Budget",
          "Signed Attendance Sheet",
          "Monthly Procurement Report",
          "Conflict of Interest Form",
        ],
      },
    ],
  },
  {
    code: "4.0",
    title: "Environmental and Waste Management",
    marksLabel: "5 marks",
    icon: "Trash2",
    indicators: [
      {
        code: "4.1",
        title: "Sanitation Services",
        maxScore: 3,
        meansOfVerification: [
          "Sanitation reports",
          "IGF PVs",
          "Physical verification",
          "Pictures",
        ],
      },
      {
        code: "4.2",
        title: "Availability of Sanitation Service Providers",
        maxScore: 3,
        meansOfVerification: [
          "Register of Service Providers",
          "Sanitation reports",
          "Contracts with service providers",
          "Monitoring reports",
          "Environmental Sanitation Strategy and Action Plan",
        ],
      },
    ],
  },
  {
    code: "5.0",
    title: "Functional Capacity of Assembly",
    marksLabel: "Administration and human resource issues",
    icon: "Building2",
    indicators: [
      {
        code: "5.1",
        title: "General Assembly Meetings and Approvals",
        maxScore: 8,
        meansOfVerification: [
          "Invitation letters",
          "Minutes of Meetings or PRCC Reports",
          "Dispatch book",
          "Attendance book",
          "PVs for allowances and logistics",
          "WhatsApp or email",
        ],
      },
      {
        code: "5.2",
        title: "Meetings of the Public Relations and Complaints Committee of the Assembly",
        maxScore: 6,
        meansOfVerification: [
          "Minutes of Meetings or PRCC Reports",
          "List of Members",
          "Register of cases submitted to the PRCC",
          "Reports on actions taken on the committee recommendations",
        ],
      },
      {
        code: "5.3",
        title: "Meetings of the Sub-District Structures and security reports",
        maxScore: 6,
        note: "Include follow-up on implementation of SDS recommendations in this assessment block.",
        meansOfVerification: [
          "Invitation letters and Minutes of Meetings",
          "Meeting attendance book with members' contact numbers",
          "Records on all established sub-district structures",
          "Records on revenue collected by all established sub-district structures",
          "Memos, PVs and bank statements on transfer of ceded revenue",
        ],
      },
      {
        code: "5.4",
        title: "Management Meetings",
        maxScore: 4,
        meansOfVerification: [
          "Invitation Letters",
          "Minutes of Management meetings",
          "List of decisions taken",
        ],
      },
    ],
  },
  {
    code: "6.0",
    title: "Staff Development and Appraisal Systems",
    marksLabel: "Training and capacity building",
    icon: "GraduationCap",
    indicators: [
      {
        code: "6.1",
        title: "Implementation of Capacity Building Plan",
        maxScore: 5,
        meansOfVerification: [
          "Date of submission of Quarterly Training Reports",
          "Technical and financial proposals",
          "Signed contract and participants' list",
          "Training manuals or course handouts",
          "Training Needs Assessment (TNA)",
          "PVs and supporting documents",
          "Individual Consultancy records",
        ],
      },
      {
        code: "6.1A",
        title: "Training Needs Assessment (TNA) for 2026 conducted in August 2025",
        maxScore: 3,
        meansOfVerification: [
          "TNA report",
          "Attendance sheets",
          "Memos",
          "Minutes",
        ],
      },
      {
        code: "6.2",
        title: "Performance Appraisal under the Local Government Service Appraisal System",
        maxScore: 4,
        meansOfVerification: [
          "Appraisal Reports",
          "Staff Performance Appraisals",
        ],
      },
    ],
  },
  {
    code: "7.0",
    title: "Financial Management and Auditing",
    marksLabel: "Functional capacity in financial management and auditing",
    icon: "Landmark",
    indicators: [
      {
        code: "7.1",
        title: "Publication of Monthly and Quarterly Financial Statement",
        maxScore: 6,
        meansOfVerification: [
          "Copies of Financial Statements",
          "Dispatch Book",
        ],
      },
      {
        code: "7.2",
        title: "Functionality of Budget Committee",
        maxScore: 4,
        meansOfVerification: [
          "Attendance Book",
          "Reports of Hearing",
          "List of Panel Members",
          "Schedule of Hearing",
        ],
      },
      {
        code: "7.2A",
        title: "Issuance of Warrants for Financial Transactions and Payments",
        maxScore: 2,
        meansOfVerification: [
          "Issued warrants list",
          "Treasury or accounting reports",
          "Disbursement vouchers",
          "Audit confirmations",
        ],
      },
      {
        code: "7.3",
        title: "Prompt Responsiveness to 2024 External Audit Queries",
        maxScore: 5,
        meansOfVerification: [
          "Attendance Book",
          "Minutes of Meetings",
          "External Audit Report",
          "Dispatch Book",
        ],
      },
      {
        code: "7.4",
        title: "Functionality of the Internal Audit Unit",
        maxScore: 6,
        meansOfVerification: [
          "Dispatch Book",
          "2nd Quarter 2024 Internal Audit Report",
          "Copy of the Annual Audit Committee Report",
        ],
      },
      {
        code: "7.5",
        title: "Responsiveness to the Internal Audit Observations",
        maxScore: 4,
        meansOfVerification: [
          "1st Quarter 2024 Internal Audit Report",
          "Status of implementation of the 1st Quarter 2024 Internal Audit Report",
          "Revised Guidelines of Audit Committees",
        ],
      },
      {
        code: "7.6",
        title: "Asset Register",
        maxScore: 5,
        meansOfVerification: [
          "Copy of 2024 Asset Register",
          "Embossment of Assets",
          "Signed Minutes of the FACU meeting",
        ],
      },
    ],
  },
  {
    code: "8.0",
    title: "Fiscal Capacity",
    marksLabel: "Public interest infrastructure",
    icon: "Wrench",
    indicators: [
      {
        code: "8.1",
        title: "Maintenance of Infrastructure of Public Interest",
        maxScore: 3,
        meansOfVerification: [
          "O&M Plan",
          "Budget records",
          "Expenditure reports",
          "Implementation or inspection reports",
        ],
      },
    ],
  },
];
